module.exports = __webpack_public_path__ + "static/media/3.fba16e85.jpg";